import styled from 'styled-components';
import { Col } from '../shared/styled';

export const AppContainer = styled(Col)`
  position: relative;
`;

export const PageContent = styled.div`
  padding: 15px;
  position: relative;
  z-index: 0
`;

export const NavOverlay = styled.div`
  background-color: ${props => props.navMenuOpen ? props.theme.mainColor : props.theme.white};
  height: 100vh;
  width: 100vw;
  position: fixed;
  transition: background-color 2s;
  z-index: ${props => props.navMenuOpen ? '1' : '-1'};
`;